/**
 * Floating label list for the Errors bucket (sibling of the Manual Actions popup).
 * Rows are multi-select: a selected row is bold with a highlighted background. "All errors" (first row)
 * selects the union of every error label. Row labels are the raw aggregated error message (no translation).
 */
import { observer } from "mobx-react";
import "./rma-list-errors-popup.scss";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import RmaListErrorsPopupRow from "./rma-list-errors-popup-row/rma-list-errors-popup-row";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    onToggle: (value: string) => void;
    onToggleAll: () => void;
}

const RmaListErrorsPopup: React.FC<IProps> = observer(({ rmaListFiltersStore, onToggle, onToggleAll }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    const selected = rmaListFiltersStore.selectedErrorLabels;
    const allSelected = rmaListFiltersStore.areAllErrorsSelected;

    return (
        <div className="rma-list-errors-popup">
            <RmaListErrorsPopupRow
                label={getTranslation("ALL_ERRORS", scope)}
                count={rmaListFiltersStore.errorsTotal}
                isSelected={allSelected}
                onToggle={onToggleAll}
            />
            {rmaListFiltersStore.errorOptions.map((option) => (
                <RmaListErrorsPopupRow
                    key={option.value}
                    label={option.value}
                    count={option.count}
                    isSelected={selected.includes(option.value)}
                    onToggle={() => onToggle(option.value)}
                />
            ))}
        </div>
    );
});

export default RmaListErrorsPopup;
